module.exports = __webpack_public_path__ + "img/goods13-2.33d4583e.jpg";